// Shared market loads fetcher — used by LoadBoard and AIDispatchChat.
//
// Disabled: this used to return 4 hardcoded fake loads (fake broker names,
// fake phone numbers) presented to drivers as if they were live outside
// freight. That's actively misleading — a driver could call a real
// company's phone number about a load that doesn't exist. Returns an
// empty list until this is wired to a real load-board API (e.g. Trulos):
//
// const res = await fetch(
//   `https://trulos.com/api/loads.json?lat=${lat}&lng=${lng}&radius=100&equipment=${truckType}`
// );
// return await res.json();

export const fetchMarketLoads = async (_homeBase, _truckType) => {
  return [];
};
